import { actions } from "../../utils/constants"

export const addInventoryListAction = (data) => {
    return { type: actions.SET_INVENTORY_LIST, data }
}

export const updateInventoryListAction = (boxId, field, value) => {
    return { type: actions.UPDATE_INVENTORY_LIST, boxId, field, value }
}